import tw, { styled } from 'twin.macro'

export const FileInputSection = styled.div(({ fullWidth = false }) => [
  tw`flex flex-col gap-4`,
  !fullWidth && tw`col-span-8`,
  fullWidth && tw`col-span-12`
])
